module.exports = __webpack_public_path__ + "img/phone.b259467.webp";